import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translateService: TranslateService;
  selectedLang = new BehaviorSubject<string>(
    localStorage.getItem('lang') || 'en'
  );

  constructor(private injector: Injector) {
    setTimeout(() => {
      this.translateService = this.injector.get(TranslateService);
      this.translateService.setDefaultLang(this.selectedLang.value);
      this.translateService.use(this.selectedLang.value);
    });
  }

  setLanguage(lang: string) {
    this.selectedLang.next(lang);
    localStorage.setItem('lang', lang);
    this.translateService?.use(lang);
  }
}
